// @flow
import { CategoryExperiencesActionTypes } from './constants';

const INIT_STATE = {
    categoryExperience: {},
    listaCategoryExperiences: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type CategoryExperiencesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { categoryExperience?: {} | null, listaCategoryExperiences?: [] | null, loading?: boolean, +value ?: boolean };

const CategoryExperiences = (state: State = INIT_STATE, action: CategoryExperiencesAction): any => {
    switch (action.type) {
        case CategoryExperiencesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case CategoryExperiencesActionTypes.GET_CATEGORY_EXPERIENCE: {
                    return {
                        ...state,
                        categoryExperience: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoryExperiencesActionTypes.LIST_CATEGORIES_EXPERIENCE: {
                    return {
                        ...state,
                        listaCategoryExperiences: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case CategoryExperiencesActionTypes.UPDATE_CATEGORY_EXPERIENCE:
                case CategoryExperiencesActionTypes.ADD_CATEGORY_EXPERIENCE: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoryExperiencesActionTypes.DELETE_CATEGORY_EXPERIENCE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoryExperiencesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case CategoryExperiencesActionTypes.GET_CATEGORY_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        categoryExperience: {},
                        loading: false,
                    };
                }
                case CategoryExperiencesActionTypes.LIST_CATEGORIES_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaCategoryExperiences: [],
                        loading: false,
                    };
                }
                case CategoryExperiencesActionTypes.UPDATE_CATEGORY_EXPERIENCE:
                case CategoryExperiencesActionTypes.ADD_CATEGORY_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case CategoryExperiencesActionTypes.DELETE_CATEGORY_EXPERIENCE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case CategoryExperiencesActionTypes.GET_CATEGORY_EXPERIENCE:
            return { ...state, error: false, loading: true };
        case CategoryExperiencesActionTypes.LIST_CATEGORIES_EXPERIENCE:
            return { ...state, error: false, loading: true };
        case CategoryExperiencesActionTypes.ADD_CATEGORY_EXPERIENCE:
            return { ...state, error: false, loadingForm: true };
        case CategoryExperiencesActionTypes.UPDATE_CATEGORY_EXPERIENCE:
            return { ...state, error: false, loadingForm: true };
        case CategoryExperiencesActionTypes.DELETE_CATEGORY_EXPERIENCE:
            return { ...state, error: false, loading: true };
        case CategoryExperiencesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                categoryExperience: {},
                listaCategoryExperiences: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default CategoryExperiences;
